import React, {useContext} from 'react';
import {LanguageContext} from "../languages/LanguageContext";
import {Link} from "react-router-dom";
import {FaRegNewspaper} from "react-icons/fa";
import GalleryPreview from "./GalleryPreview";
import {MdOutlineVideoLibrary} from "react-icons/md";

const LatestNews = () => {
	const { language, translations } = useContext(LanguageContext);
	return (
		<div className='important-container max-w flex jc-sb gap-2 w-full latest-news-container'>
			<div className='content-container flex gap-sm w-full jc-sb wrap'>
				<div className='flex wrap gap-sm'>
					<div className='wrapper'>
						<p>{translations[language]["latestNews"]}</p>
						<h3 dangerouslySetInnerHTML={{__html: translations[language]["latestNewsTitle"]}}></h3>
						<ul className='list-container flex col'>
							<li>{translations[language]["latestNewsContent"]}</li>
						</ul>
						<Link target='_blank' to='/images/landing/latest-news-article.jpg'><b className='flex ai-c'><FaRegNewspaper /> {translations[language]["newspaperFragment"]}</b></Link>
						<Link target='_blank' to='https://www.btvon.at/index.php/video/4135/er%C3%B6ffnung-erasmushaus-althofen/#'><b className='flex ai-c'><MdOutlineVideoLibrary />{translations[language]["video"]}</b></Link>
						{translations[language]["forMoreInfo"]}, <Link target='_blank' to='https://www.kleinezeitung.at/kaernten/stveit/17959917/sie-sorgt-fuer-unterkuenfte-fuer-auslaendische-jugendliche'><b>{translations[language]["clickHere"]}</b></Link>
					</div>
				</div>
				<div className='latest-news flex col'>
					<div className='news-image'>
						<img src='/images/landing/latest-news.jpg' alt='latest news althofen'/>
					</div>
					<GalleryPreview
						folder={'latest-news/'}
						imageCount={68}
						prefix={'latest-'}
						news={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default LatestNews;